module.exports = __webpack_public_path__ + "static/media/9308968632_9f4ba1e0cc_z.73dda23a.jpg";